/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Website} from '../../../../../models/website.model';
import {WccService} from '../../../../../services/wcc-service';

@Component({
	selector: 'app-dialog-new-site',
	templateUrl: './dialog-new-site.component.html'
})
export class DialogNewSiteComponent implements OnInit {

	defaultMaxLength: number = 500;
	result: Website;


	constructor(
		public dialogRef: MatDialogRef<DialogNewSiteComponent>,
		public wccService: WccService,
		@Inject(MAT_DIALOG_DATA) public data: {
			site: Website
		}
	) { }

	ngOnInit() {
		this.result = Object.assign({}, this.data.site);
	}

	onNoClick(): void {
		this.dialogRef.close(null);
	}

	onYesClick(): void {
		this.wccService.updateWebsite(this.result).subscribe( (response: any) => {
		if (!response.error) {
			this.dialogRef.close(1);
		} else {
			this.dialogRef.close(0);
		}
	});
	}

}
